// services/eventService.js

// const API_BASE_URL = 'http://localhost:8000/api/event'; // Replace with your actual API base URL
import { BASE_URL } from "../config/api";


export const createEvent = async (formData) => {
  try {
    const token = localStorage.getItem("token");
    const response = await fetch(`${BASE_URL}/event/createEvent`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}` // Ensure this header is set
      },
      body: formData // Don't stringify FormData
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to create event');
    }

    return await response.json();
  } catch (error) {
    console.error('Error in createEvent:', error);
    throw error;
  }
};
export const fetchAllEvents = async () => {
  try {
    const response = await fetch(`${BASE_URL}/event/fetchAllEvents`);
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    const data = await response.json();
    return data.events || [];
  } catch (error) {
    console.error('Error fetching events:', error);
    throw error;
  }
};

export const fetchAllEventsWithUsers = async () => {
  try {
    const events = await fetchAllEvents();

    const eventsWithUserData = await Promise.all(
      events.map(async (event) => {
        try {
          const token = localStorage.getItem("token");
          const userRes = await fetch(`${BASE_URL}/user/fetchUserById/${event.user_id}`, {
            headers: {
              'Authorization': `Bearer ${token}`
            }
          });
          
          if (!userRes.ok) {
            throw new Error('Failed to fetch user');
          }
          
          const userData = await userRes.json();

          return {
            ...event,
            userName: userData.user?.user_name || "Unknown",
            userDesignation: userData.user?.user_designation || "Not Available",
            userImage: userData.user?.user_profile_img || "default.png"
          };
        } catch (err) {
          console.error(`Error fetching user ${event.user_id}:`, err);
          return { 
            ...event, 
            userName: "Unknown",
            userRole: "Not Available",
            userImage: "default.png"
          };
        }
      })
    );

    return eventsWithUserData;
  } catch (error) {
    throw new Error(error.message || "Failed to fetch events with users");
  }
};


export const fetchEventById = async (id) => {
  try {
    const response = await fetch(`${BASE_URL}/event/fetchEventById/${id}`);
    if (!response.ok) {
      throw new Error('Failed to fetch event');
    }
    return await response.json();
  } catch (error) {
    console.error('Error fetching event:', error);
    throw error;
  }
};

export const updateEvent = async (id, formData) => {
  try {
    const response = await fetch(`${BASE_URL}/event/updateEvent/${id}`, {
      method: "POST",
      body: formData,
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to update event');
    }

    return await response.json();
  } catch (error) {
    console.error('Error updating event:', error);
    throw error;
  }
};




export const fetchUserById = async (id) => {
  const response = await fetch(`${BASE_URL}/user/fetchUserById/${id}`);
  
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || "Failed to fetch user");
  }

  const data = await response.json();
  return data.user;
};